<template>
<div id="ap_agentes_aduanales" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-top justify-top>
            <v-menu-lateral-apendice />
            <v-flex xs10>
                <base-material-card color="primary" icon="library_books" title="Agentes Aduanales Generales" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>

                            <exportar-excel :data="datafiltered" :exportFields="agentes.camposexcel" name="Agentes.xlsx" >
                                <v-btn fab dark x-small color="success" title="Exportar Registros" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel :data="agentes.camposLayout" :exportFields="agentes.encabezadoLayout" name="Layout Agentes Aduanales.xlsx" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>
                        &nbsp;
                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="65%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" @click.native="modal = false" >
                                            cancel
                                        </v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>
                                                {{ update ? "Actualizar" : "Nuevo" }} Agente
                                                Aduanal
                                            </strong>
                                        </span>
                                    </v-card>                                    
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                            <v-row>
                                                <v-col xs="12" sm="4" md="4" lg="4" >
                                                    <v-text-field label="Patente" type="text" v-model="model.patente" :rules="[rules.required, verificaLongitud]" @keyup="soloNumeros('patente')" maxlength="4" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="4" md="4" lg="4" >
                                                    <v-text-field label="CURP del AA o del Representante" type="text" @input="model.curp_agente = model.curp_agente.toUpperCase()" v-model="model.curp_agente" :rules="[curplen]" maxlength="20" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="4" md="4" lg="4" >
                                                    <v-text-field label="RFC Agente Aduanal" type="text" @input="model.rfc_agente = model.rfc_agente.toUpperCase()" v-model="model.rfc_agente" :rules="[rules.required, rules.rfclen]" maxlength="20" ></v-text-field>
                                                </v-col>
                                                
                                            </v-row>
                                            <v-row>
                                                <v-col xs="12" sm="4" md="4" lg="4" >
                                                    <v-text-field label="Nombre del Agente Aduanal o Representante" type="text"  v-model="model.nombre" maxlength="350" :rules="[rules.required]" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="4" md="4" lg="4" >
                                                    <v-text-field label="Primer Apellido del Agente Aduanal o Representante" type="text"  v-model="model.primer_apellido" maxlength="350" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="4" md="4" lg="4" >
                                                    <v-text-field label="Segundo Apellido del Agente Aduanal o Representante" type="text"  v-model="model.segundo_apellido" maxlength="350" ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col xs="12" sm="7" md="7" lg="7" >
                                                    <v-text-field label="Nombre de la sociedad del AA.RGCE 1.4.4" type="text" v-model="model.nombre_sociedad" maxlength="350" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="5" md="5" lg="5" >
                                                    <v-text-field label="RFC que factura servicios aduanales" type="text" @input="model.rfc_servicios_aduanales = model.rfc_servicios_aduanales.toUpperCase()" v-model="model.rfc_servicios_aduanales" maxlength="20" :rules="[rules.required,rules.rfclen]" ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>                                                
                                                <v-col xs="12" sm="12" md="12" lg="12" >
                                                    <v-text-field label="Número de serie del certificado de firma electrónica avanzada" type="text" v-model="model.numero_serie" maxlength="350" ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col xs="12" sm="6" md="6" lg="6" >
                                                    <v-text-field label="Aduana de Adscripcion" type="text" v-model="model.aduana_adscripcion" maxlength="350" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="6" md="6" lg="6" >
                                                    <v-text-field label="Identificador OEA" type="text" v-model="model.identificador_oea" maxlength="350" ></v-text-field>
                                                </v-col>
                                            </v-row>                                       
                                            <v-row>
                                                <v-col xs="12" sm="3" md="3" lg="3" >
                                                    <v-autocomplete v-model="model.tipo_figura" :items="tipos" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Figura" :rules="[rules.required]" >
                                                    </v-autocomplete>                                                    
                                                </v-col>
                                                <v-col xs="12" sm="9" md="9" lg="9" >
                                                    <v-text-field label="Observaciones" type="text"  v-model="model.observaciones" maxlength="550" ></v-text-field>
                                                </v-col>                                                
                                            </v-row>                                       
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon>Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >
                            <v-client-table ref="principalTable" :data="agentes.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="
                          getRegistro(props.row.id_agente_admin)
                        " title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id_agente_admin)
                        " title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>

                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>

        </v-layout>
    </v-container>

</div>
</template>

<script>
import axios from "axios";
import menuLateral from "@/views/apendices/MenuLateralApendice.vue";
import powerTitulo from "@/components/powerTitulo.vue";

export default {
    components: {
        "v-menu-lateral-apendice": menuLateral,
        "v-power-titulo": powerTitulo
    },
    mounted() {},

    data: () => ({
        tipos:[{
            "id": "TIPFIG.AGE",
            "text": "Agente Aduanal"
            }, {
            "id": "TIPFIG.EXP",
            "text": "Exportador"
            }, {
            "id": "TIPFIG.IMP",
            "text": "Importador"
            }, {
            "id": "TIPFIG.MAN",
            "text": "Mandatario"
        }],
        url_active: location.href,        
        editable: true,             
        title: "Agentes Aduanales Generales",        
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Utilerías",
                disabled: true,
                to: ""
            },
            {
                text: "Apendices",
                disabled: true,
                to: ""
            }
        ],
        columns: [            
            "patente",                     
            "curp_agente",
            "rfc_agente",       
            "nombre_completo",                 
            "rfc_servicios_aduanales",
            "nombre_sociedad",
            "actions"
        ],
        options: {            
            headings: {
                "patente":"Patente",  
                "curp_agente":"CURP Agente",             
                "rfc_agente":"RFC Agente Aduanal",   
                "nombre_completo":"Nombre AA o del Representante",                
                "rfc_servicios_aduanales":"RFC que factura servicios aduanales",                   
                "nombre_sociedad":"Razón Social del RFC que factura servicios aduanales",
                actions: "Operaciones"
            },            
        },
        URL: "",
        show_loading: true,
        loading: false,
        modal: false,
        update: false,
        search: "",
        model: {
            id_agente_admin: 0,
            patente:"",            
            curp_agente:"",
            rfc_agente:"",
            nombre:"",
            primer_apellido:"",
            segundo_apellido:"",            
            nombre_sociedad:"", //nombre_sociedad
            rfc_servicios_aduanales:"", //rfc_servicios_aduanales
            numero_serie:"", // - OPCIONAL
            aduana_adscripcion:"", // - OPCIONAL
            identificador_oea:"",  //- OPCIONAL
            tipo_figura:"",  //- OPCIONAL
            observaciones:"" // - OPCIONAL,
        },
        rules: {
            required: v => !!v || "Este campo es requerido",
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Correo electrónico no valido";
            },
            rfclen: v => (v && v.length >= 9) || "Debe tener al menos 9 caractéres",            
        },
        agentes: {
            selected: [],
            camposexcel: {
                Patente: "patente",                
                "Nombre del Agente Aduanal o Representante":"nombre",
                "Primer Apellido del Agente Aduanal o Representante":"primer_apellido",
                "Segundo Apellido del Agente Aduanal o Representante":"segundo_apellido",
                "CURP del AA o del Representante": "curp_agente",
                "RFC Agente Aduanal":"rfc_agente",                
                "Nombre de la sociedad del AA.RGCE 1.4.4":"nombre_sociedad",
                "RFC que factura servicios aduanales": "rfc_servicios_aduanales",
                "Número de serie del certificado de firma electrónica avanzada":"numero_serie", 
                "Aduana de adscripción":"aduana_adscripcion", 
                "Identificador OEA": "identificador_oea", 
                "Tipo Figura":"tipo_figura",
                "Observaciones":"observaciones",                 
            },
    
            items: [0],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {
                //agente
                patente: "patente",     
                nombre:"nombre",
                primer_apellido:"primer_apellido",
                segundo_apellido:"segundo_apellido",           
                curp_agente: "curp_agente",
                rfc_agente:"rfc_agente",                
                nombre_sociedad: "nombre_sociedad",
                rfc_servicios_aduanales: "rfc_servicios_aduanales",      
                numero_serie:"numero_serie", 
                aduana_adscripcion:"aduana_adscripcion", 
                identificador_oea: "identificador_oea", 
                tipo_figura:"tipo_figura",
                observaciones:"observaciones",                 
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{
                //agente
                patente: "[Número de patente - 4 dígitos]",                
                nombre:"[Nombre del Agente Aduanal o Representante]",
                primer_apellido:"[Primer Apellido del Agente Aduanal o Representante]",
                segundo_apellido:"[Segundo Apellido del Agente Aduanal o Representante]",
                curp_agente: "[CURP del AA o del Representante]",
                rfc_agente: "[RFC Agente Aduanal]",                
                nombre_sociedad: "[Nombre de la sociedad del AA.RGCE 1.4.4]",
                rfc_servicios_aduanales: "[RFC que factura servicios aduanales]",
                numero_serie:"[Número de serie del certificado de firma electrónica avanzada - Opcional]", 
                aduana_adscripcion:"[Aduana de adscripción - Opcional]", 
                identificador_oea: "[Identificador OEA - Opcional]",  
                tipo_figura: "[Tipo Figura - Opcional]",
                observaciones: "[Observaciones - Opcional]",
            }]
        },       
        camposObligatorios: {
            "patente": "Patente",
            "rfc_agente": "RFC del agente",
            "nombre": "Nombre del agente",
            "rfc_servicios_aduanales": "RFC que factura servicios aduanales",            
        },

    }),
    computed: {
        datafiltered() {
            if (this.$refs.principalTable != null) {                
                return this.$refs.principalTable.allFilteredData;
            } else {
                return this.agentes.items;
            }
        }
    },
    methods: {
        curplen: function(){
            if(this.model.curp_agente!=null && this.model.curp_agente.toString().length>0){
                if(this.model.curp_agente.toString().length<10)
                    return "Debe tener al menos 10 caractéres";                
            }
            return true;             
        },
        verificaLongitud: function(value){ 
            if (value.toString().length != 4 ){
                return "Deben ser 4 dígitos";
            } 
            return true;
        },
        soloNumeros: function(campo){ 
            const pattern = /^[\d]*$/;
            let value = this.model[campo];
            if (!pattern.test(value) ){
                this.model[campo] = this.model[campo].substring(0,this.model[campo].length-1);
                this.soloNumeros(campo);
                //console.log("INVALIDO")
            } 
            //else 
                //console.log("VALIDO");             
        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo Agente Aduanal";
                this.update = false;
            } else {
                this.title = "Actualizar Agente Aduanal";
                this.update = true;
            }
            this.modal = true;
        },
        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }            
        },

        guardar() {
            const datos = this.model;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_agente_admin + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    })
                    .catch(err => {
                        try {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                if (typeof err.response.data == "string") {
                                    let pos = errores.indexOf(err.response.data);
                                    if (pos < 0) {
                                        errores += err.response.data;
                                        errores += "<br>";
                                    }
                                } else{
                                    Object.keys(err.response.data).forEach(function (key) {
                                            var errors = err.response.data[key];                                            
                                            //Este trae 2 niveles, por eso el campo queda en la key2
                                            Object.keys(errors).forEach(function (key2) {
                                                let pos = errores.indexOf(key + ": " + errors[key2]);
                                                if (pos < 0) {
                                                    errores += key + ": " + errors[key2];
                                                    errores += "<br>";
                                                }
                                            });                                             
                                        });
                                }                                      
                                    
                            }
                                
                            this.$swal({
                                position: "center",
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos",
                                footer: errores,
                                //showConfirmButton: false,
                            });
                            //console.log(err);
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                            this.modal = false;
                        } catch (error) {
                            console.log(error);
                        }
                        
                    });
            }
        },
        
        cargar: function () {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            axios
                .get(this.URL)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.agentes.items = res.data;
                        for(var k in this.agentes.items){
                            this.agentes.items[k].nombre_completo = this.agentes.items[k].nombre+" "+this.agentes.items[k].primer_apellido+" "+this.agentes.items[k].segundo_apellido;
                        }
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {                   
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },
       
        getRegistro: function (id_registro) {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            axios
                .get(this.URL + id_registro + "/")
                .then(response => {
                    this.model = response.data;                    
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value){
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    axios
                    .delete(this.URL + id_registro + "/")
                    .then(response => {
                        this.cargar();
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: ""
                        });
                    });
                }
                    
            });
        }, //delete
        
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }

            for (var key in this.camposObligatorios) {
                if (keys.indexOf(key) == -1)
                    errores += '<br/>' + "- El campo '" + key + "' es obligatorio.";
            }

            return errores == '' ? true : errores;
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var renglonesLeidos = 0;
            var erroresText = "";
            const pattern = /^[\d]*$/;
            try {
                for (var k in results) {
                    renglonesLeidos++;
                    results[k]["user_updated"] = thisObject.$local_storage.get("email");                    
                    var obligatorios = thisObject.verificaObligatorios(results[k]);
                    if (obligatorios !== true) {
                        errores++;
                        if (erroresText.indexOf(obligatorios) == -1)
                            erroresText += obligatorios;
                    } else {
                        if ( results[k]['patente'].toString().length > 4 ){
                            errores++;
                            erroresText += "- Patente \"" + results[k]["patente"] + "\" debe ser de 4 dígitos <br>";
                        } else if (!pattern.test(results[k]['patente'].toString())){   
                            errores++;
                            erroresText += "- Patente \"" + results[k]["patente"] + "\" debe ser de 4 dígitos <br>";
                        } else {
                            results[k]['patente'] = results[k]['patente'].toString().padStart(4,"0");
                        }

                    }                    
                    //console.log("Key is " + k + ", value is" + results[k]['patente']);
                }

                if (renglonesLeidos == 0) {
                    errores++;
                    erroresText +=
                        "- No hay datos en el layout. Verifique que exista información a partir del 3er renglón.\n";
                }

                return {
                    errores: errores,
                    erroresText: erroresText
                };
            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message
                });
            }
            //}); //promise
        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = "";            
            try {
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText
                    });
                    
                } else {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var resultadoFinal = [];
                    for (var k in results) {
                        
                        var agente = {
                            patente: results[k]["patente"],
                            curp_agente: results[k]["curp_agente"].toString().toUpperCase(),
                            rfc_agente: results[k]["rfc_agente"].toString().toUpperCase(),
                            nombre: results[k]["nombre"],
                            primer_apellido:results[k]["primer_apellido"],
                            segundo_apellido:results[k]["segundo_apellido"],
                            nombre_sociedad: results[k]["nombre_sociedad"],
                            rfc_servicios_aduanales: results[k]["rfc_servicios_aduanales"],
                            numero_serie: results[k]["numero_serie"],
                            aduana_adscripcion: results[k]["aduana_adscripcion"],
                            identificador_oea: results[k]["identificador_oea"],   
                            tipo_figura: results[k]["tipo_figura"],   
                            observaciones:results[k]["observaciones"],                               
                            user_updated: results[k]["user_updated"]
                        };
                        resultadoFinal.push(agente);
                    }
                    
                    axios
                        .post(this.URL + "importar_agentes_admin/", resultadoFinal)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                if (typeof err.response.data == "string") {
                                    let pos = errores.indexOf(err.response.data);
                                    if (pos < 0) {
                                        errores += err.response.data;
                                        errores += "<br>";
                                    }
                                } else
                                    for (var i = 0; i < err.response.data.length; i++) {
                                        Object.keys(err.response.data[i]).forEach(function (key) {
                                            var errors = err.response.data[i][key];                                            
                                            //Este trae 2 niveles, por eso el campo queda en la key2
                                            Object.keys(errors).forEach(function (key2) {
                                                let pos = errores.indexOf(key + ": " + errors[key2]);
                                                if (pos < 0) {
                                                    errores += key + ": " + errors[key2];
                                                    errores += "<br>";
                                                }
                                            });                                             
                                        });
                                    }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo. \nVerifique que los encabezados correspondan con el layout.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();                            
                        });
                }
            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message
                });
                this.$root.$dialogLoader.hide();
            }
        },  

    }, //methods

    created: function () {
        this.URL = this.$hostname + "catalogos/agentes_admin/";        
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.cargar();     
    }
};
</script>